import { format, isValid, parseISO, startOfDay } from "date-fns";

export const formatDate = (
  date?: string | null,
  dateFormat: string = "dd/MM/yyyy",
): string => {
  if (!date) {
    return "";
  }
  const parsed = parseISO(date.split("T")[0]);
  return isValid(parsed) ? format(parsed, dateFormat) : date;
};

export const formatDateOnly = (date: Date): string => {
  return format(date, "yyyy-MM-dd");
};

export const parseDateOnly = (dateString: string): Date => {
  return startOfDay(parseISO(dateString));
};
